import { useState } from "react";

/**
 * 游戏化相关状态 Hook
 */
const useGameState = () => {
  const [gameProfile, setGameProfile] = useState(null);
  const [gameConfig, setGameConfig] = useState(null);
  const [feedbackDelta, setFeedbackDelta] = useState(null);
  const [levelUpInfo, setLevelUpInfo] = useState(null);
  const [unlockedAchievements, setUnlockedAchievements] = useState([]);

  // 重置游戏化状态
  const resetGameState = () => {
    setGameProfile(null);
    setGameConfig(null);
    setFeedbackDelta(null);
    setLevelUpInfo(null);
    setUnlockedAchievements([]);
  };

  return {
    gameProfile,
    setGameProfile,
    gameConfig,
    setGameConfig,
    feedbackDelta,
    setFeedbackDelta,
    levelUpInfo,
    setLevelUpInfo,
    unlockedAchievements,
    setUnlockedAchievements,
    resetGameState,
  };
};

export default useGameState;
